module.exports = __webpack_public_path__ + "static/img/dialog_bg.e5e5bb4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/public/dialog_bg.png
// module id = prd0
// module chunks = 166